import React, { Component } from "react";

class Menu extends Component {

    render() {
        return(
            <React.Fragment>
                  <header id="home" class="navbar navbar-default fixed-top">
                    <div class="container">
                    <a class="navbar-brand" href="/">
                        <img class="" src={"../assets/img/logo.png"} alt=""></img>
                    </a>
                        
                    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon ico-menu"></span>
                        {/* <!-- <span class="navbar-toggler-icon"><i class="fas fa-bars"></i></span> --> */}
                    </button>
                        
                        <nav class="navbar navbar-expand-lg">
                        <div class="collapse navbar-collapse navbar-responsive" id="navbarSupportedContent">
                            <ul class="navbar-nav ml-auto">
                                <li class="nav-item">
                                <a class="nav-link" href="/quem-somos">A ITechMed</a>
                                </li>
                                <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Nossas Soluções
                                </a>
                                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <a class="dropdown-item" href="/temperatura">Monitoramento de Temperatura e Umidade</a>
                                    <a class="dropdown-item" href="/ativos">Rastreabilidade de Equipamentos</a>
                                    <a class="dropdown-item" href="/atendimento-de-check-up">Atendimento de Check-up</a>
                                    <a class="dropdown-item" href="/leitos-e-centros-cirurgicos">Gestão de Ocupação de Leitos e Centros cirúrgicos</a>
                                    <a class="dropdown-item" href="/limpeza">Gestão de Processo de Limpeza</a>
                                    <a class="dropdown-item" href="/rfid">Soluções RFID</a>
                                    <a class="dropdown-item" href="/atendimento-clinicas">Atendimento em Clínicas Radiológicas</a>
                                </div>
                                </li>

                                <li class="nav-item">
                                <a class="nav-link" href="/contato">Contato</a>
                                </li>

                                <li class="nav-item nav-rede">
                                <a class="nav-link" href="https://www.linkedin.com/company/itech-med-tecnologia-em-saude/" target="_blank"><img src={"../assets/img/ico-linkedin.svg"} alt="Linkedin"></img></a>
                                </li>

                                <li class="nav-item nav-rede">
                                <a class="nav-link btn-whatsapp" href="https://wa.me/5511956297239?text=Olá,%20acessei%20o%20site%20e%20estou%20entrando%20em%20contato."><span class="ico-whatsapp"></span> 11 <b>9.5629-7239</b></a>
                                </li>
                            </ul>
                        </div>
                    </nav>
                    </div>
                </header>
            </React.Fragment>
        );
    }
}

export default Menu;